import { render } from "./ContainersWithMostViolationsWidget.vue?vue&type=template&id=f5e5d9e2&scoped=true"
import script from "./ContainersWithMostViolationsWidget.vue?vue&type=script&lang=js"
export * from "./ContainersWithMostViolationsWidget.vue?vue&type=script&lang=js"

import "./ContainersWithMostViolationsWidget.vue?vue&type=style&index=0&id=f5e5d9e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e5d9e2"]])

export default __exports__